import {jwtDecode} from "jwt-decode";

export const isTokenExpired = (token) => {
    if (!token) return true;

    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Convert to seconds
        return decoded.exp < currentTime;
    } 
    catch (error) {
        console.error("Token decoding failed:", error);
        return true;
    }
}

export const getTokenBPO = () => {
    return localStorage.getItem("@ProsperBI:bpoToken");
}

export const getUserTokenBPO = () => {
    const token = getTokenBPO();
    let user = null;
    if (token) {
        try {
            user = jwtDecode(token);
            user.foto = localStorage.getItem("@ProsperBI:foto");
        } 
        catch (error) {
            console.error("Token decoding failed:", error);
        }
    }
    return user;
}